import { render, staticRenderFns } from "./CustomerDeliveryAddressList.vue?vue&type=template&id=21d0f235&scoped=true"
import script from "./CustomerDeliveryAddressList.vue?vue&type=script&lang=js"
export * from "./CustomerDeliveryAddressList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d0f235",
  null
  
)

export default component.exports